<template>
  <div class="bg-gray-50">
    <div class="max-h-[calc(100vh-3.5rem)] min-h-[calc(100vh-3.5rem)] overflow-y-auto">
      <div class="topleft">
        <div class="w-96 p-4">
          <img src="@/assets/Logo-CST.png" alt="Logo"  />
        </div>
      </div>
      <div class="middle">
        <h1>User Portal</h1>
        <div class="flex flex-col gap-1"
          v-if="userReady && enableUserNotAllowedError">
          <span class="text-red-400 text-2xl font-semibold">You do not have permission to view any data</span>
          <span class="text-gray-400 text-md">If you think this is in error, please contact technology@drivecst.org</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import events from '../services/events'
import user from '../services/user/user'

export default {
  props: {
    user: {},
  },
  eventCallbackIds: {},
  data() {
    return {
      userReady: false,
      enableUserNotAllowedError: false,
      interval: null,
      time: null,
    }
  },
  // beforeUnmount() {
  // eslint-disable-next-line
  beforeDestroy() {
    // prevent memory leak
    clearInterval(this.interval)
    events.remove(
      'enableUserNotAllowedError',
      this.$options.eventCallbackIds.enableUserNotAllowedError
    )
  },
  async created() {
    // update the time every second
    this.interval = setInterval(() => {
      // Concise way to format time according to system locale.
      // In my case this returns "3:48:00 am"
      this.time = new Date()
    }, 1000)

    this.$options.eventCallbackIds.enableUserNotAllowedError = events.register(
      'enableUserNotAllowedError',
      (value) => {
        this.enableUserNotAllowedError = value
      }
    )

    await user.ready()
    this.userReady = true
  },
}
</script>

<style>
/* Position text in the top-left corner */
.topleft {
  position: relative;
  top: 0;
  left: 16px;
}

/* Position text in the bottom-left corner */
.bottomleft {
  position: absolute;
  bottom: 0;
  left: 16px;
}

/* Position text in the middle */
.middle {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

/* Style the <hr> element */
hr {
  margin: auto;
  width: 40%;
}
</style>
